import cx from "clsx";
import React from "react";
import { Colours } from "../../utils/colours";
import { Button, type ButtonProps } from "../common";
import { Arrow, Chevron } from "../common/Icons";
import * as styles from "./Pagination.module.scss";
export interface PaginationProps {
	onFirstClick: () => void;
	onPreviousClick: () => void;
	onNextClick: () => void;
	onLastClick: () => void;

	firstDisabled?: boolean;
	previousDisabled?: boolean;
	nextDisabled?: boolean;
	lastDisabled?: boolean;
	position?: number;
	total?: number;

	slim?: boolean;
	noOffset?: boolean;
	showAllProps?: ButtonProps;
	isOnListingPage?: boolean;
}

export const Pagination: React.FC<PaginationProps> = ({
	onFirstClick,
	onPreviousClick,
	onNextClick,
	onLastClick,
	firstDisabled,
	previousDisabled,
	nextDisabled,
	lastDisabled,
	position,
	total,
	slim = false,
	noOffset = false,
	showAllProps,
	isOnListingPage = false,
}) => {
	if (total < 2) {
		return null;
	}

	// TODO - add aria announcements for screen readers
	return (
		<div
			className={cx(styles.paginationwrapper, {
				[styles.slim]: !showAllProps && slim,
				[styles.narrow]: slim,
				[styles.nooffset]: noOffset,
				[styles.withshowall]: !!showAllProps,
				[styles.nobackground]: isOnListingPage,
			})}
		>
			<div className={styles.controls}>
				<button
					className={styles.largepaginationcontrol}
					type="button"
					aria-label="Go to first"
					disabled={firstDisabled}
					onClick={onFirstClick}
				>
					<Arrow
						fill={Colours.MIDNIGHT}
						withBorder={false}
						width="24px"
						height="24px"
					/>
				</button>
				<button
					className={
						isOnListingPage
							? styles.largepaginationcontrol
							: styles.smallpaginationcontrol
					}
					type="button"
					aria-label="Previous"
					disabled={previousDisabled}
					onClick={onPreviousClick}
				>
					<Chevron rotation={-90} width="20px" height="20px" />
				</button>
				<p
					className={styles.paginationtext}
				>{`${Math.min(position + 1, total)} of ${total}`}</p>
				<button
					className={
						isOnListingPage
							? styles.largepaginationcontrol
							: styles.smallpaginationcontrol
					}
					type="button"
					aria-label="Next"
					disabled={nextDisabled}
					onClick={onNextClick}
				>
					<Chevron rotation={90} width="20px" height="20px" />
				</button>
				<button
					className={styles.largepaginationcontrol}
					type="button"
					aria-label="Go to last"
					disabled={lastDisabled}
					onClick={onLastClick}
				>
					<Arrow
						fill={Colours.MIDNIGHT}
						withBorder={false}
						width="24px"
						height="24px"
						rotation={-180}
					/>
				</button>
			</div>
			{showAllProps && (
				<div className={styles.showall}>
					<Button {...showAllProps} size="small" />
				</div>
			)}
		</div>
	);
};
